var HighlightShapeView = require('./highlight'),
    StrikeThroughShapeView = require('./strikeThrough'),
    RedactionNoteLevelView = require('./redaction/noteLevelView'),
    RedactionShapeLevelView = require('./redaction/shapeLevelView');

/**
 * Utilize factory instead of another reference on the model prototype
 * ShapeOrNoteLevel: 'shape' or 'note'
 * - I think intended if meant for top level ( search module ) or zone level
 * - Could also mean dialog or not -- eg could implement note level dialogs
 */


module.exports = function( noteModel, shapeOrNoteLevel ) {

    // Currently nothing/unused ( and now not broken into different levels )
    if ( noteModel.isHighlightNote() ) {

        return HighlightShapeView;

    }

    // For now use the same for floating - non floating
    if (  noteModel.isRedactionNote() ) {

        return shapeOrNoteLevel === 'note'
            ? RedactionNoteLevelView
            : RedactionShapeLevelView;

    }


};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/notePropertyViews/shapeProperties/factory.js
 ** module id = 600
 ** module chunks = 0
 **/